import { render, staticRenderFns } from "./SVGGradient.vue?vue&type=template&id=78f358f4&"
import script from "./SVGGradient.vue?vue&type=script&lang=js&"
export * from "./SVGGradient.vue?vue&type=script&lang=js&"
import style0 from "./SVGGradient.vue?vue&type=style&index=0&id=78f358f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports